import { Weight } from "@faire/web/slate/Font/utils";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var CollectedCSAT = function CollectedCSAT() {
  return /*#__PURE__*/React.createElement(StyledTypography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "dpTPcy",
    defaultMessage: "Thanks for your feedback!"
  }));
};
var StyledTypography = styled(Typography).withConfig({
  displayName: "CollectedCSAT__StyledTypography"
})(["&&&{margin-top:", ";font-weight:", ";}"], getSpacing("4x"), Weight.medium);